import { FC, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { CheckCircle } from '@eqi-investimentos/icons/web';
import { Box, Flex } from '@eqi-investimentos/react';
import { Drawer } from '@/components/molecules/Drawer';
import { IfRender, MapRender } from '@/utils/jsx';
import { RegisterForm } from './RegisterForm';
export const RegisterDrawer: FC = () => {
  const [step, setStep] = useState(0);
  const queryClient = useQueryClient();
  const invalidateQuery = () => {
    queryClient.invalidateQueries({
      queryKey: ['financial-planning', 'all']
    });
  };
  return <Drawer id={FINANCIAL_PLANNING_REGISTER} showIconButton={false} showHeaderBackButton={false} showCloseButton={step === 0} bodyProps={{
    p: 0
  }} closeButtonProps={{
    top: '2.75rem',
    right: 5
  }} handleBeforeDrawerClose={step === 4 ? invalidateQuery : undefined} headerProps={{
    display: 'flex',
    justifyContent: step === 4 ? 'center' : 'flex-end',
    alignItems: 'center',
    boxSizing: 'content-box',
    px: 5,
    pt: 12,
    pb: 6,
    minH: '5.875rem'
  }} headerContent={<>
          <IfRender condition={step > 0 && step < 4}>
            <Flex gap="8">
              <MapRender items={[...Array(3)]} render={(_, idx) => <Box key={idx} aria-label={`box-fill-index-${idx}`} w="10" h="10" borderRadius="50%" transition="0.3s all ease-in-out" bgColor={idx < step ? 'content.brand             ' : 'rgba(0,0,0, 0.16)'} />} />
            </Flex>
          </IfRender>
          <IfRender condition={step === 4}>
            <CheckCircle boxSize="3.125rem" color="green.500" />
          </IfRender>
        </>} data-sentry-element="Drawer" data-sentry-component="RegisterDrawer" data-sentry-source-file="RegisterDrawer.tsx">
      <RegisterForm {...{
      step,
      setStep,
      invalidateQuery
    }} data-sentry-element="RegisterForm" data-sentry-source-file="RegisterDrawer.tsx" />
    </Drawer>;
};
export const FINANCIAL_PLANNING_REGISTER = 'financial-planning-register';